import React from "react";
import Button from "components/Button";
import { Modal, ModalBody } from "reactstrap";
import { Container } from "styles/components/AlertModal";

const AlertModal = ({ InnerClassName, className, ...props }) => {
   return (
    <Modal
      isOpen={props?.isOpen}
      toggle={props?.toggle}
      backdrop={"static"}
      centered={true}
      size="lg"
      className={className}
    >
      <Container className={InnerClassName}>
        <ModalBody>
          <div style={{ display: "none" }}>
            <h3 className="modal-title">{props?.title}</h3>
          </div>
          <div className="ModalContentMsg">
            <p>{props?.content}</p>
          </div>
          <Button
            type="app-green-button submitBtn AlertBtn"
            handleClick={() => {
              if (props?.callBackAlert) props?.callBackAlert();
              else props?.toggle(!props?.isOpen);
            }}
          >
             OK
          </Button>
        </ModalBody>
      </Container>
    </Modal>
  );
};

export default AlertModal;
